import { Box } from '@mui/material';
import { RESPONSIVE_DRAWER_HEIGHT } from '../Constants';
import { MenuBar } from '../components/MenuBar';
import BillableMaterials from '../components/BillableMaterials/BillableMaterials';
import { useUserContext } from '../UserContext';

export default function BillableMaterialPage() {
  const { data: user } = useUserContext();

  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        width: '100%',
        height: `calc(100vh - ${RESPONSIVE_DRAWER_HEIGHT}px)`,
        overflow: 'hidden',
        top: RESPONSIVE_DRAWER_HEIGHT,
        padding: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ height: RESPONSIVE_DRAWER_HEIGHT }}>
        <MenuBar />
      </Box>
      {user && <BillableMaterials user={user} />}
    </Box>
  );
}
